import React from 'react'
import ZoomableImage from '../../../basic/ZoomableImage'
import styled from 'styled-components'
import * as media from '../../../media'
import BlueGalkaImage from '../../../static/blueGalka.svg'
import Image from '../../../basic/image'
import { get } from 'lodash';
import TranslateText from 'src/text/modal';
import { browserHistory } from 'react-router';


const PackageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${media.smallerThan(465)`display:block;`}
`


const Container = styled.div`

  background: rgb(235,235,235);
  display: flex;
  font-size: 15px;
  padding: 40px;
  max-width: 550px;
  min-height: 330px;
  ${media.smallerThan(920)`
    display:none;
    align-items: center;
    ${props => props.imgPos == 'before' ? 'flex-direction: column;' : 'flex-direction: column-reverse;'} 
  `}
`

const Param = ({name, value, marginLeft, fontSize, width, display, style}) => (
  <div
    style={{
      minHeight: 25,
      lineHeight: '25px',
      marginLeft,
      fontSize,
      display,
      ...(style && style),
    }}
  >
    <div style={{display: 'inline-block', width: width || 200,}}>{name}</div>
    <div
      style={{
        display: 'inline-block',
        lineHeight: 'initial',
      }}
    >
      {value}
    </div>
  </div>
)

const Title = styled.div`
  font-weight: 800;
  font-size: 1.4em;
  margin-bottom: 20px;
`

const A = styled.span`
  font-weight: 800;
  font-size: 1.2em;
  color: #0054ff; 
  cursor: pointer; 
  &:hover { 
    color: red;
  }
`

const AutoPartCard = ({
  output,
  href,
  title,
  img,
  imgPos = 'before',
  children,
  style
}) => {
  return (
    <Container
      imgPos={imgPos}
      style={style}
    >
      {imgPos == 'before' && (
        <ZoomableImage
          src={img}
          style={{
            maxHeight: 250,
            maxWidth: '100%',
          }}
          containerStyle={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '35%',
          }}
        />)}
      <div
        style={{
          marginLeft: 25,
          flexGrow: 1,
          flexShrink: 1,
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          width: '65%',
        }}
      >
        <Title>{title}</Title>
        <Param name={output.article.key} value={output.article.value}/>
        {get(output, 'weight.value') && <Param name={output.weight.key} value={output.weight.value} />}
        {get(output, 'size_package.value') && <Param name={output.size_package.key} value={output.size_package.value} />}
        {get(output, 'applicability.value') && <Param name={output.applicability.key} value={output.applicability.value} />}
        {get(output, 'complete.value') &&
          <div>
            <div
              style={{
                fontWeight: 800,
                fontSize: '1.2em',
                marginTop: 20,
              }}
            >
              {output.complete.key}
            </div>
            <div
              style={{
                marginTop: 20,
              }}
            >
              {output.complete.value}
            </div>
          </div>
        }
        <div style={{ marginTop: 20 }}>
          <TranslateText
            id="search_part__more"
            style={{ display: 'inline' }}
            render={text => <A onClick={() => browserHistory.push(href)}>{text}</A>}
          />
          <Image
            src={BlueGalkaImage}
            style={{
              transform: 'rotate(-90deg)',
              height: 7,
              marginLeft: 5,
              verticalAlign: 'middle',
            }}
          />
        </div>
        {children}
      </div>
      {imgPos == 'after' && (
        <ZoomableImage
          src={img}
          style={{
            maxHeight: 400,
            maxWidth: 250
          }}/>
      )}
    </Container>
  )
}


export default AutoPartCard



// WEBPACK FOOTER //
// ./src/finwhale/common/auto-part-card-brief/Desktop.js